import { CALL_API } from 'redux-api-middleware'
import axios from 'axios'
import {
  BASE_URL,
  USER_CREATE_REQUEST,
  USER_CREATE_SUCCESS,
  USER_CREATE_FAILURE,
  USER_CREATE_RESET,
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAILURE,
  USER_LIST_RESET,
  USER_GET_REQUEST,
  USER_GET_SUCCESS,
  USER_GET_FAILURE,
  USER_GET_RESET,
  USER_EDIT_REQUEST,
  USER_EDIT_SUCCESS,
  USER_EDIT_FAILURE,
  USER_EDIT_RESET,
  USER_DEACTIVATE_REQUEST,
  USER_DEACTIVATE_SUCCESS,
  USER_DEACTIVATE_FAILURE,
  USER_DEACTIVATE_RESET,
  USER_UPLOAD_IMAGE_REQUEST,
  USER_UPLOAD_IMAGE_SUCCESS,
  USER_UPLOAD_IMAGE_FAILURE,
  USER_EXPORT_REQUEST,
  USER_EXPORT_SUCCESS,
  USER_EXPORT_FAILURE,
  USER_EXPORT_RESET,
  USER_IMPORT_REQUEST,
  USER_IMPORT_SUCCESS,
  USER_IMPORT_FAILURE,
  USER_IMPORT_RESET,
  FAVORITE_REQUEST,
  FAVORITE_SUCCESS,
  FAVORITE_FAILURE,
  FAVORITE_RESET,
  USER_EDIT_PROFILE_RESET,
  USER_OPEN_RESPONSE_MODAL,
  USER_SET_KEYWORD_SEARCH,
  USER_SET_EDIT_COMPANY,
  USER_SET_EDIT_PERSONAL,
  USER_SET_EDIT_ROLE,
  USER_SET_EDIT_MOVEMENT,
  USER_CREATE_MOVEMENT_REQUEST,
  USER_CREATE_MOVEMENT_SUCCESS,
  USER_CREATE_MOVEMENT_FAILURE,
  USER_CREATE_MOVEMENT_RESET,
  USER_EDIT_MOVEMENT_REQUEST,
  USER_EDIT_MOVEMENT_SUCCESS,
  USER_EDIT_MOVEMENT_FAILURE,
  USER_EDIT_MOVEMENT_RESET,
  USER_DELETE_MOVEMENT_REQUEST,
  USER_DELETE_MOVEMENT_SUCCESS,
  USER_DELETE_MOVEMENT_FAILURE,
  USER_DELETE_MOVEMENT_RESET,
  USER_EDIT_PRIVILEGE_ROLE_REQUEST,
  USER_EDIT_PRIVILEGE_ROLE_SUCCESS,
  USER_EDIT_PRIVILEGE_ROLE_FAILURE,
  USER_EDIT_PRIVILEGE_ROLE_RESET,
  SHOW_MANUAL_USER,
  CLOSE_MANUAL_USER,
} from './../../constants'

export function createUser(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users`,
      method: 'POST',
      types: [
        USER_CREATE_REQUEST,
        USER_CREATE_SUCCESS,
        USER_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getUser(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users`,
      method: 'GET',
      types: [
        USER_LIST_REQUEST,
        USER_LIST_SUCCESS,
        USER_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editUser(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/${id}`,
      method: 'PUT',
      types: [
        USER_EDIT_REQUEST,
        USER_EDIT_SUCCESS,
        USER_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getUserByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/${id}`,
      method: 'GET',
      types: [
        USER_GET_REQUEST,
        USER_GET_SUCCESS,
        USER_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function deactivateUser(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/${id}/delete`,
      method: 'PUT',
      types: [
        USER_DEACTIVATE_REQUEST,
        USER_DEACTIVATE_SUCCESS,
        USER_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportUser(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/exports`,
      method: 'GET',
      types: [
        USER_EXPORT_REQUEST,
        USER_EXPORT_SUCCESS,
        USER_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function importUser(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/imports`,
      method: 'POST',
      types: [
        USER_IMPORT_REQUEST,
        USER_IMPORT_SUCCESS,
        USER_IMPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: payload,
    },
  }
}

export function editFavoriteMenu(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/${id}/favorite-menu`,
      method: 'PUT',
      types: [
        FAVORITE_REQUEST,
        FAVORITE_SUCCESS,
        FAVORITE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function createMovement(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/company_profile/${id}`,
      method: 'POST',
      types: [
        USER_CREATE_MOVEMENT_REQUEST,
        USER_CREATE_MOVEMENT_SUCCESS,
        USER_CREATE_MOVEMENT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function editMovement(movement_id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/company_profile/${movement_id}`,
      method: 'PUT',
      types: [
        USER_EDIT_MOVEMENT_REQUEST,
        USER_EDIT_MOVEMENT_SUCCESS,
        USER_EDIT_MOVEMENT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deleteMovement(movement_id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/company_profile/${movement_id}`,
      method: 'DELETE',
      types: [
        USER_DELETE_MOVEMENT_REQUEST,
        USER_DELETE_MOVEMENT_SUCCESS,
        USER_DELETE_MOVEMENT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editPrivilegeRole(user_id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/privilege/${user_id}`,
      method: 'PUT',
      types: [
        USER_EDIT_PRIVILEGE_ROLE_REQUEST,
        USER_EDIT_PRIVILEGE_ROLE_SUCCESS,
        USER_EDIT_PRIVILEGE_ROLE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function openResponseModal(payload) {
  return {
    type: USER_OPEN_RESPONSE_MODAL,
    payload,
  }
}

export function setKeywordSearch(payload) {
  return {
    type: USER_SET_KEYWORD_SEARCH,
    payload,
  }
}

export function setEditPersonal(payload) {
  return {
    type: USER_SET_EDIT_PERSONAL,
    payload,
  }
}

export function setEditCompany(payload) {
  return {
    type: USER_SET_EDIT_COMPANY,
    payload,
  }
}

export function setEditRole(payload) {
  return {
    type: USER_SET_EDIT_ROLE,
    payload,
  }
}

export function setEditMovement(payload) {
  return {
    type: USER_SET_EDIT_MOVEMENT,
    payload,
  }
}

export function openManual() {
  return {
    type: SHOW_MANUAL_USER,
  }
}

export function closeManual() {
  return {
    type: CLOSE_MANUAL_USER,
  }
}

// export function requestUpload() {
//   return {
//     type: USER_UPLOAD_IMAGE_REQUEST,
//   }
// }
// export function successUpload(res) {
//   return {
//     type: USER_UPLOAD_IMAGE_SUCCESS,
//     data: res,
//   }
// }
// export function failureUpload(res) {
//   return {
//     type: USER_UPLOAD_IMAGE_FAILURE,
//     data: res,
//   }
// }
export const requestUpload = () => ({
  // return {
  type: USER_UPLOAD_IMAGE_REQUEST,
  // }
})
export const successUpload = (res) => ({
  // return {
  type: USER_UPLOAD_IMAGE_SUCCESS,
  data: res,
  // }
})
export const failureUpload = (res) => ({
  // return {
  type: USER_UPLOAD_IMAGE_FAILURE,
  data: res,
  // }
})

export function uploadImageProfile(payload, access_token) {
  requestUpload()
  axios({
    method: 'post',
    url: 'http://localhost:8000/upload/user-profile-image',
    headers: {
      'authorization': `bearer ${access_token}`,
    },
    data: payload,
  }).then(data => {
    successUpload(data)
  }).catch(error => {
    failureUpload(error)
  })
  // return {
  //   [CALL_API]: {
  //     endpoint: `${BASE_URL}/upload/user-profile-image`,
  //     method: 'POST',
  //     types: [
  //       USER_UPLOAD_IMAGE_REQUEST,
  //       USER_UPLOAD_IMAGE_SUCCESS,
  //       USER_UPLOAD_IMAGE_FAILURE,
  //     ],
  //     headers: {
  //       // 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundaryyrV7KO0BoCBuDbTL',
  //       'authorization': `bearer ${access_token}`,
  //     },
  //     data: payload,
  //   },
  // }
}

export function resetListUser() {
  return {
    type: USER_LIST_RESET,
  }
}
export function resetCreateUser() {
  return {
    type: USER_CREATE_RESET,
  }
}
export function resetEditUser() {
  return {
    type: USER_EDIT_RESET,
  }
}
export function resetEditProfileUser() {
  return {
    type: USER_EDIT_PROFILE_RESET,
  }
}
export function resetGetUser() {
  return {
    type: USER_GET_RESET,
  }
}
export function resetDeactivateUser() {
  return {
    type: USER_DEACTIVATE_RESET,
  }
}
export function resetExportUser() {
  return {
    type: USER_EXPORT_RESET,
  }
}
export function resetImportUser() {
  return {
    type: USER_IMPORT_RESET,
  }
}
export function resetEditFavoriteMenu() {
  return {
    type: FAVORITE_RESET,
  }
}
export function resetCreateMovement() {
  return {
    type: USER_CREATE_MOVEMENT_RESET,
  }
}
export function resetEditMovement() {
  return {
    type: USER_EDIT_MOVEMENT_RESET,
  }
}
export function resetEditPrivilege() {
  return {
    type: USER_EDIT_PRIVILEGE_ROLE_RESET,
  }
}
export function resetDeleteMovement() {
  return {
    type: USER_DELETE_MOVEMENT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/employee/employee-action.js